import { Link } from "react-router-dom";
import Logo from "./Logo";
import SocialLinks from "./SocialLinks";
import { NAV_LINKS, SITE_URL } from "@/lib/constants";
import { useSite } from "@/context/SiteContext";
import { openCookieSettings } from "@/lib/consent";

const SERVICE_LINKS = [
  { label: "Construcții", to: "/servicii/constructii" },
  { label: "Renovări & interioare", to: "/servicii/renovari-interioare" },
  { label: "Instalații", to: "/servicii/instalatii" },
  { label: "Exterior", to: "/servicii/exterior" },
  { label: "Energie", to: "/servicii/energie" },
  { label: "Lucrări speciale", to: "/servicii/lucrari-speciale" },
];

const LEGAL_LINKS = [
  { label: "Termeni și condiții", to: "/termeni-conditii" },
  { label: "Politica de confidențialitate", to: "/politica-confidentialitate" },
  { label: "Politica cookies", to: "/politica-cookies" },
  { label: "Reclamații și SAL", to: "/reclamatii" },
];

export default function Footer() {
  const { config } = useSite();
  return (
    <footer className="border-t border-white/10 bg-ink-950" data-testid="footer">
      <div className="container-brox grid gap-10 py-12 sm:py-20 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted-foreground">
            Un singur contact. Tot proiectul. Brox Construct reunește execuția, specialiștii și furnizorii
            necesari proiectului tău într-un singur punct de contact.
          </p>
          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-copper">
            broxconstruct.ro
          </p>
          <p className="mt-2 text-xs text-muted-foreground" data-testid="footer-legal-entity">Brox Consulting S.R.L.</p>
          <SocialLinks className="mt-8" idPrefix="footer-social" />
        </div>

        <nav className="lg:col-span-2" aria-label="Servicii">
          <p className="label-brox">Servicii</p>
          <ul className="space-y-3">
            {SERVICE_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-paper/75 transition-colors hover:text-copper" data-testid={`footer-service-${l.to.split("/").pop()}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="lg:col-span-2" aria-label="Companie">
          <p className="label-brox">Companie</p>
          <ul className="space-y-3">
            {NAV_LINKS.filter((l) => l.to !== "/").map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-paper/75 transition-colors hover:text-copper" data-testid={`footer-link-${l.to.replace(/\//g, "")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="lg:col-span-3">
          <p className="label-brox">Legal</p>
          <ul className="space-y-3">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-paper/75 transition-colors hover:text-copper" data-testid={`footer-legal-${l.to.replace(/\//g, "")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-5 space-y-2.5">
            <a
              href="https://reclamatiisal.anpc.ro/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-block"
              data-testid="footer-anpc-sal"
            >
              <img src="/anpc-sal.svg" alt="Soluționarea Alternativă a Litigiilor — ANPC" width="250" height="62" loading="lazy" className="h-auto w-[250px] max-w-full" />
            </a>
            <button
              onClick={() => openCookieSettings()}
              className="block text-xs text-muted-foreground transition-colors hover:text-copper"
              data-testid="footer-cookie-settings"
            >
              SETĂRI COOKIES
            </button>
          </div>
          <div className="mt-8 space-y-1.5 text-sm text-muted-foreground">
            {config.phone && <p>{config.phone}</p>}
            {config.email && <p>{config.email}</p>}
            {config.working_hours && <p className="whitespace-pre-line">{config.working_hours}</p>}
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="container-brox flex flex-col items-start justify-between gap-2 pb-fab pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} BROX CONSTRUCT. Toate drepturile rezervate.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-copper/80" data-testid="footer-slogan">CA LA NOI, LA NIMENI.</p>
        </div>
      </div>
    </footer>
  );
}
